const categoriesClass2 = [
  {
    id: 1,
    name: "Words",
    nameTr: "Kelimeler",
    icon: "📚",
    color: "#FF9AA2",
  },
  {
    id: 2,
    name: "Friends",
    nameTr: "Arkadaşlar",
    icon: "👫",
    color: "#FFB7B2",
  },
  {
    id: 3,
    name: "Classroom",
    nameTr: "Sınıfta",
    icon: "🏫",
    color: "#FFDAC1",
  },
  {
    id: 4,
    name: "Numbers",
    nameTr: "Sayılar",
    icon: "🔢",
    color: "#E2F0CB",
  },
  {
    id: 5,
    name: "Colors",
    nameTr: "Renkler",
    icon: "🎨",
    color: "#B5EAD7",
  },
  {
    id: 6,
    name: "Playground",
    nameTr: "Oyun Alanında",
    icon: "🛝",
    color: "#C7CEEA",
  },
  {
    id: 7,
    name: "Body Parts",
    nameTr: "Vücut Bölümleri",
    icon: "👋",
    color: "#FDCFDF",
  },
  {
    id: 8,
    name: "Pets",
    nameTr: "Evcil Hayvanlar",
    icon: "🐶",
    color: "#A2D2FF",
  },
  {
    id: 9,
    name: "Fruits",
    nameTr: "Meyveler",
    icon: "🍎",
    color: "#FFD6A5",
  },
  {
    id: 10,
    name: "Animals",
    nameTr: "Hayvanlar",
    icon: "🦁",
    color: "#CAFFBF",
  },
];

const categoriesClass3 = [
  {
    id: 1,
    name: "Greetings",
    nameTr: "Selamlaşmalar",
    icon: "👋",
    color: "#FF9AA2",
  },
  {
    id: 2,
    name: "My Family",
    nameTr: "Ailem",
    icon: "👨‍👩‍👧‍👦",
    color: "#FFB7B2",
  },
  {
    id: 3,
    name: "People I Love",
    nameTr: "Sevdiğim İnsanlar",
    icon: "❤️",
    color: "#FFDAC1",
  },
  {
    id: 4,
    name: "Feelings",
    nameTr: "Duygular",
    icon: "😊",
    color: "#E2F0CB",
  },
  {
    id: 5,
    name: "Toys and Games",
    nameTr: "Oyuncaklar ve Oyunlar",
    icon: "🎮",
    color: "#B5EAD7",
  },
  {
    id: 6,
    name: "My House",
    nameTr: "Evim",
    icon: "🏠",
    color: "#C7CEEA",
  },
  {
    id: 7,
    name: "In My City",
    nameTr: "Şehrimde",
    icon: "🏙️",
    color: "#FDCFDF",
  },
  {
    id: 8,
    name: "Transportation",
    nameTr: "Ulaşım",
    icon: "🚗",
    color: "#A2D2FF",
  },
  {
    id: 9,
    name: "Weather",
    nameTr: "Hava Durumu",
    icon: "☁️",
    color: "#FFD6A5",
  },
  {
    id: 10,
    name: "Nature",
    nameTr: "Doğa",
    icon: "🌲",
    color: "#CAFFBF",
  },
];

const categoriesClass4 = [
  {
    id: 1,
    name: "Classroom Rules",
    nameTr: "Sınıf Kuralları",
    icon: "✏️",
    color: "#FF9AA2",
  },
  {
    id: 2,
    name: "Nationality",
    nameTr: "Milliyet",
    icon: "🌎",
    color: "#FFB7B2",
  },
  {
    id: 3,
    name: "Cartoon Character",
    nameTr: "Çizgi Film Karakter",
    icon: "🐭",
    color: "#FFDAC1",
  },
  {
    id: 4,
    name: "Free Time",
    nameTr: "Boş Zaman",
    icon: "🎮",
    color: "#E2F0CB",
  },
  {
    id: 5,
    name: "My Day",
    nameTr: "Günüm",
    icon: "🌞",
    color: "#B5EAD7",
  },
  {
    id: 6,
    name: "Fun With Science",
    nameTr: "Bilimle Eğlence",
    icon: "🧪",
    color: "#C7CEEA",
  },
  {
    id: 7,
    name: "Jobs",
    nameTr: "Meslekler",
    icon: "👷",
    color: "#FDCFDF",
  },
  {
    id: 8,
    name: "My Clothes",
    nameTr: "Kıyafetlerim",
    icon: "👚",
    color: "#A2D2FF",
  },
  {
    id: 9,
    name: "My Friends",
    nameTr: "Arkadaşlarım",
    icon: "👭",
    color: "#FFD6A5",
  },
  {
    id: 10,
    name: "Food and Drinks",
    nameTr: "Yiyecek ve İçecekler",
    icon: "🍕",
    color: "#CAFFBF",
  },
];
const categoriesDemo = [
  {
    id: 1,
    name: "Demo Words",
    nameTr: "Kelimeler",
    icon: "📚",
    color: "#FF9AA2",
  },
  {
    id: 2,
    name: "Demo Friends",
    nameTr: "Arkadaşlar",
    icon: "👫",
    color: "#FFB7B2",
  },
  {
    id: 3,
    name: "Demo Classroom",
    nameTr: "Sınıfta",
    icon: "🏫",
    color: "#FFDAC1",
  },
  {
    id: 4,
    name: "Word Game",
    nameTr: "kelime oyunu",
    icon: "🎮",
    color: "#FFDAC1",
  },
];
const categoriesExtra = [
  {
    id: 0,
    name: "home ",
    nameTr: " ana sayfa",
    icon: "🏠",
    color: "#FF9AA2",
  },
  {
    id: 1,
    name: "True & False",
    nameTr: " Doğru & Yanlış",
    icon: "✅",
    color: "#FF9AA2",
  },
  {
    id: 2,
    name: "Listen & Find",
    nameTr: "Dinle & Bul",
    icon: "🎧",
    color: "#FFB7B2",
  },
  {
    id: 3,
    name: "Question & Answer",
    nameTr: "Soru & Cevap",
    icon: "⁉️",
    color: "#FFDAC1",
  },
  {
    id: 4,
    name: "Description",
    nameTr: "tanımlama",
    icon: "💡",
    color: "#FFDAC1",
  },
];
export {
  categoriesClass2,
  categoriesClass3,
  categoriesClass4,
  categoriesDemo,
  categoriesExtra,
};
